import { cn } from "@/utils/cn";
import { memo } from "react";

interface HeartIconProps {
  className?: string;
}

export const HeartIcon = memo(function HeartIcon({ className }: HeartIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("fill-white", className)}
    >
      <path d="M16.5208 3C14.5848 3 12.8898 3.8325 11.8333 5.23969C10.7767 3.8325 9.08169 3 7.14575 3C5.60471 3.00174 4.12729 3.61468 3.03761 4.70436C1.94793 5.79404 1.33499 7.27146 1.33325 8.8125C1.33325 15.375 11.0636 20.6869 11.4779 20.9062C11.5872 20.965 11.7092 20.9958 11.8333 20.9958C11.9573 20.9958 12.0793 20.965 12.1886 20.9062C12.6029 20.6869 22.3333 15.375 22.3333 8.8125C22.3315 7.27146 21.7186 5.79404 20.6289 4.70436C19.5392 3.61468 18.0618 3.00174 16.5208 3ZM11.8333 19.3875C10.1214 18.39 2.83325 13.8459 2.83325 8.8125C2.83474 7.66921 3.28957 6.57317 4.098 5.76475C4.90643 4.95632 6.00246 4.50149 7.14575 4.5C8.96919 4.5 10.5001 5.47125 11.1395 7.03125C11.196 7.16881 11.2921 7.28646 11.4157 7.36926C11.5392 7.45207 11.6845 7.49627 11.8333 7.49627C11.982 7.49627 12.1273 7.45207 12.2508 7.36926C12.3744 7.28646 12.4705 7.16881 12.527 7.03125C13.1664 5.46844 14.6973 4.5 16.5208 4.5C17.664 4.50149 18.7601 4.95632 19.5685 5.76475C20.3769 6.57317 20.8318 7.66921 20.8333 8.8125C20.8333 13.8384 13.5433 18.3891 11.8333 19.3875Z" />
    </svg>
  );
});
